module.exports = __webpack_public_path__ + "static/img/图层 18.3ece91ef.png";